// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InsuredPersonCase-module__statusIndicator--DHxWK {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 5px;
}

.InsuredPersonCase-module__green--MkzvJ {
    color: green;
}

.InsuredPersonCase-module__red--RRy6X {
    color: red;
}

.InsuredPersonCase-module__greenIndicator--amOPj {
    background-color: green;
}

.InsuredPersonCase-module__redIndicator--WUm6t {
    background-color: red;
}

.InsuredPersonCase-module__status--dsAUF {
    display: flex;
    gap: 30px;
}

.InsuredPersonCase-module__tabsBox--_JZWq>div>div {
    display: flex;
    flex-wrap: wrap;
}

.InsuredPersonCase-module__tabsBox--_JZWq {
    max-width: 1000px;
}

.InsuredPersonCase-module__flexBox--cUP16 {
    display: flex;
    align-items: center;
    justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/pages/insured-person-case/InsuredPersonCase.module.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC","sourcesContent":[".statusIndicator {\r\n    display: inline-block;\r\n    width: 10px;\r\n    height: 10px;\r\n    border-radius: 50%;\r\n    margin-right: 5px;\r\n}\r\n\r\n.green {\r\n    color: green;\r\n}\r\n\r\n.red {\r\n    color: red;\r\n}\r\n\r\n.greenIndicator {\r\n    background-color: green;\r\n}\r\n\r\n.redIndicator {\r\n    background-color: red;\r\n}\r\n\r\n.status {\r\n    display: flex;\r\n    gap: 30px;\r\n}\r\n\r\n.tabsBox>div>div {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.tabsBox {\r\n    max-width: 1000px;\r\n}\r\n\r\n.flexBox {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"statusIndicator": `InsuredPersonCase-module__statusIndicator--DHxWK`,
	"green": `InsuredPersonCase-module__green--MkzvJ`,
	"red": `InsuredPersonCase-module__red--RRy6X`,
	"greenIndicator": `InsuredPersonCase-module__greenIndicator--amOPj`,
	"redIndicator": `InsuredPersonCase-module__redIndicator--WUm6t`,
	"status": `InsuredPersonCase-module__status--dsAUF`,
	"tabsBox": `InsuredPersonCase-module__tabsBox--_JZWq`,
	"flexBox": `InsuredPersonCase-module__flexBox--cUP16`
};
export default ___CSS_LOADER_EXPORT___;
